////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//Note: These view models are used by the views of both GradesController#show & CourseworkEntriesController#new
//They are also used to render question previews on the instructor side.
//So please test the entire loop of coursework authoring, submission and grade review when making a change here.
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import vis from 'vis';
let CourseworkFields = {};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
CourseworkFields.BaseField = function BaseField(data, parent, skip_mapping, mapping) {
  data.isCurrent = ko.observable(false);
  data.isCompleted = ko.observable(false);
  data.isRequired = ko.observable(false); //If incomplete, this will force the user to complete the question
  data.isRequiredConfirmation = ko.observable(false); //If incomplete, this will let the user continue if they confirm
  data.isCorrect = ko.observable(null);
  data.isPartiallyCorrect = ko.observable(null);
  data.isMeta = ko.observable(false);
  data.isSectionBreak = ko.observable(false);
  data.isGraded = ko.computed(function () {
    return !_.isEmpty(data.grade_entry) && !isNaN(parseInt(data.grade_entry.id));
  });
  data.isPreviewing = ko.observable(data.isPreviewing);
  data.isGrading = ko.observable(data.isGrading);
  data.isDisabled = ko.computed(function () {
    return data.isGrading() || data.isGraded();
  });
  data.isExtraCredit = ko.computed(function () {
    return data.grading_criteria && data.grading_criteria.extra_credit;
  });

  data.question_answer = ko.observable(); //Answer which gets stored in the DB
  data.question_answers = ko.observableArray();

  data.getFDObj = function(item) {
    return item.field_definition()[item.rand_fd_index()];
  };

  data.getQuestion = function(item) {
    var field = item.getFDObj(item);
    return field.question();
  };

  data.isSelectedOption = function(item, index) {
    return ((item.coursework_field_entry != undefined) && (item.coursework_field_entry.value != undefined) && (item.coursework_field_entry.value() == index()));
  };

  data.isCorrectOption = function(fdObj) {
    if (data.isGraded()) {
      return fdObj.selected();
    }
  };

  data.initQuestionUI = function() {
    if (data.isCurrent() || data.isPreviewing()) {
      setTimeout(function() {
        Kadenze.UIUtil.initExpandableText();
      }, 300);
    }
  };

  // Set the grade status except for WrittenResponse/MetaField which can't be "right" or "wrong"
  if(data.isGraded() && (data._type != 'WrittenResponseField' || data._type != 'MetaField')) {
    if(data.grade_entry.value >= data.grading_criteria.points) {
      data.isCorrect(true);
    } else if(data.grade_entry.value > 0 && data.grade_entry.value < data.grading_criteria.points) {
      data.isPartiallyCorrect(true);
    } else if(data.grade_entry.value == 0) {
      data.isCorrect(false);
    }
  }
  data.question_status = ko.computed(function() {
    var status = '';

    if(data.isCompleted()) {
      status = Kadenze.I18n.t('coursework_entries.new.complete');
    } else {
      status = Kadenze.I18n.t('coursework_entries.new.incomplete');
    }

    if(data.isCorrect() === true) {
      status = Kadenze.I18n.t('coursework_entries.new.correct');
    } else if(data.isPartiallyCorrect() === true) {
      status = Kadenze.I18n.t('coursework_entries.new.partially_correct');
    } else if(data.isCorrect() === false) {
      status = Kadenze.I18n.t('coursework_entries.new.incorrect');
    }

    if(data.isCurrent()) {
      status = Kadenze.I18n.t('coursework_entries.new.current');
    }

    if(data._type == 'MetaField') {
      data.isMeta(true);
      status = '';
    } else if(data._type == 'SectionBreakField') {
      data.isSectionBreak(true);
      status = '';
    }
    return status;
  });
  data.question_type = ko.computed(function() {
    var nameKey = {
      FillInTheBlankField: Kadenze.I18n.t('form_builder.fill_in_the_blank'),
      WrittenResponseField: Kadenze.I18n.t('form_builder.written_response'),
      MultipleChoiceField: Kadenze.I18n.t('form_builder.multiple_choice'),
      TrueFalseField: Kadenze.I18n.t('form_builder.true_false'),
      RatingField: Kadenze.I18n.t('form_builder.rating'),
      AnswerBuilderField: Kadenze.I18n.t('form_builder.answer_builder'),
      TimelineField: Kadenze.I18n.t('form_builder.timeline'),
      InteractiveTimelineField: Kadenze.I18n.t('form_builder.interactive_timeline'),
      MatrixField: Kadenze.I18n.t('form_builder.matrix'),
      MetaField: '',
      SectionBreakField: ''
    };

    return nameKey[data._type];
  });

  //If the coursework is graded, get the variant from the entry otherwise pick a random
  var default_variant = data.field_definition ? Math.floor(Math.random() * data.field_definition.length) : 0;
  var variant = Kadenze.Util.objFromString(data, 'coursework_field_entry.variant', default_variant);
  data.rand_fd_index = ko.observable(variant);

  //Set the student answers if present

  if(data.coursework_field_entry) {
    var responses;
    try {
      responses = JSON.parse(data.coursework_field_entry.value);
    } catch (e) {
      responses = data.coursework_field_entry.value;
    }

    data.question_answer(responses);
  }

  if(data.isGraded()) {
    if (data._type != 'MetaField')
      data.isCompleted(true);
  } else {
    //Basic completed check for rest of the fields
    data.question_answer.subscribe(function(value) {
      if (value && value != '') {
        data.isCompleted(true);
      } else {
        data.isCompleted(false);
      }
    });
  }

  return skip_mapping ? data : ko.mapping.fromJS(data, mapping || {});
};

CourseworkFields.TrueFalseField = function TrueFalseField(data, parent, mapping) {
  var data = new CourseworkFields.BaseField(data, parent, true);
  var fd = data.field_definition[data.rand_fd_index()];
  //Don't do anything special if this isn't a multi_response type
    if(data.isGraded()) {
      //Transform existing answers into an array for presentation
      var mapped_answers = ko.mapping.fromJS(data.question_answer());
      data.question_answers(mapped_answers());

      data.isCompleted(true);
    } else {
      //Build an array of objects to store which options are selected
      //This could have been done with a simple array but unfortunately knockout bindings didn't work as expected
      for (var i = 0; i < fd.options.length; i++) {
        var row = {index: ko.observable(i), selected: ko.observable(false)};
        data.question_answers.push(row);
      }

      //If this is a resubmission grab the existing answers and seed them into the question_answers array
      if (data.question_answer()) {
        var mapped_answers = ko.mapping.fromJS(data.question_answer());
        data.question_answers(mapped_answers());
      }

      //Subscribe to all the answer fields
      ko.computed(function() {
        var json_data = ko.mapping.toJSON(data.question_answers());
        data.question_answer(json_data);

        //Update question status
        var completed = _.any(data.question_answers(), function(row) {
          return row.selected();
        });
        data.isCompleted(completed);
      });
  }


  return ko.mapping.fromJS(data, mapping || {});
};

CourseworkFields.MultipleChoiceField = function MultipleChoiceField(data, parent, mapping) {
  var data = new CourseworkFields.BaseField(data, parent, true);
  var fd = data.field_definition[data.rand_fd_index()];
  //Don't do anything special if this isn't a multi_response type
    if(data.isGraded()) {
      //Transform existing answers into an array for presentation
      var mapped_answers = ko.mapping.fromJS(data.question_answer());
      data.question_answers(mapped_answers());

      data.isCompleted(true);
    } else {
      //Build an array of objects to store which options are selected
      //This could have been done with a simple array but unfortunately knockout bindings didn't work as expected
      for (var i = 0; i < fd.options.length; i++) {
        var row = {index: ko.observable(i), selected: ko.observable(false)};
        data.question_answers.push(row);
      }

      //If this is a resubmission grab the existing answers and seed them into the question_answers array
      if (data.question_answer()) {
        var mapped_answers = ko.mapping.fromJS(data.question_answer());
        data.question_answers(mapped_answers());
      }

      //Subscribe to all the answer fields
      ko.computed(function() {
        var json_data = ko.mapping.toJSON(data.question_answers());
        data.question_answer(json_data);

        //Update question status
        var completed = _.any(data.question_answers(), function(row) {
          return row.selected();
        });
        data.isCompleted(completed);
      });
  }

  return ko.mapping.fromJS(data, mapping || {});
};
CourseworkFields.WrittenResponseField = function WrittenResponseField(data, parent, mapping) {
  var data = new CourseworkFields.BaseField(data, parent, true);

  data.getQuestionAnswer = function(item, index) {
    var fdObj = item.getFDObj(item);
    if (fdObj.answer_collection() != null) {
      //Build a map of the real indexes because some collections are
      //set to be repeated multiple times so we need to take that into account
      var indexMap = [];
      _.each(fdObj.answer_collection(), function(collection, real_index) {
        _.times(collection.times(), function(n) { indexMap.push(real_index); });
      });
      var idx = indexMap[index];
      return fdObj.answer_collection()[idx].answers();
    } else {
      return fdObj.answer();
    }
  };

  if(data.isGraded()) {
    //Transform existing answers into an array for presentation
    var answers = data.question_answer() ? data.question_answer().toString().split('<kadenze/>') : [];
    $.each(answers, function(index, answer) {
      data.question_answers.push({index: ko.observable(index), answer: ko.observable(answer)});
    });

    data.isCompleted(true);
  } else {
    //Build an array to store the # of answers required from the student based on the # of answer collections there are in the selected variant
    data.number_of_answers = 1;
    var answer_collection = data.field_definition[data.rand_fd_index()].answer_collection;

    if (!_.isEmpty(answer_collection) && _.isArray(answer_collection) && answer_collection.length > 0) {
      data.number_of_answers = _.reduce(answer_collection, function(num, list){ return (parseInt(list.times) || 0) + num; }, 0);
    }

    for (var i = 0; i < data.number_of_answers; i++) {
      data.question_answers.push({index: ko.observable(i), answer: ko.observable()});
    }

    //Convert the question_answers back into a string to store in the db
    data.update_question_answer = function() {
      var answers_arry = _.map(data.question_answers(), function(question_answer){ return question_answer.answer(); });
      answers_arry = $.grep(answers_arry, Boolean);

      //Update question status
      if(data.number_of_answers == answers_arry.length) {
        data.isCompleted(true);
      } else {
        data.isCompleted(false);
      }

      data.question_answer(answers_arry.join('<kadenze/>'));
    };

    //Subscribe to all the answer fields
    ko.utils.arrayForEach(data.question_answers(), function(question_answer) {
      question_answer.answer.subscribe(data.update_question_answer);
    });

    //If this is a resubmission grab the existing answers and seed them into the question_answers array
    var dataQuestionAnswers = data.question_answer() && (typeof data.question_answer() === "string")
    var answers = dataQuestionAnswers ? data.question_answer().split('<kadenze/>') : [];
    $.each(answers, function(index, answer) {
      data.question_answers()[index].answer(answer);
    });
  }

  return ko.mapping.fromJS(data, mapping || {});
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
CourseworkFields.FillInTheBlankField = function FillInTheBlankField(data, parent, mapping) {
  return new CourseworkFields.WrittenResponseField(data, parent, mapping);
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
CourseworkFields.AnswerBuilderField = function AnswerBuilderField(data, parent, mapping) {
  var data = new CourseworkFields.BaseField(data, parent, true);
  data.answer_collection = data.field_definition[data.rand_fd_index()].answer_collection || [];

  data.getPreview = function(parts, index) {
    var selected_options = _.map(parts(), function(part) { return _.isEmpty(part.part) ? '' : part.part(); });
    return String.fromCharCode(65 + index) + ') ' + selected_options.join(' ');
  };

  data.getOptions = function(csv) {
    return _.shuffle(_.compact(_.map(csv.split(';'), function(option) { return option.trim(); })));
  };

  if(data.isGraded()) {
    //Transform existing answers into an array for presentation
    var mapped_answers = ko.mapping.fromJS(data.question_answer());
    data.question_answers(mapped_answers());

    data.isCompleted(true);
  } else {
    //Build an array to store the # of answers required from the student based on the # of answer collections there are in the selected variant
    data.number_of_answers = parseInt(data.field_definition[data.rand_fd_index()].answers_expected || 1);

    for (var a = 0; a < data.number_of_answers; a++) {
      var answer = {index: ko.observable(a), parts: ko.observableArray([])};
      for (var i = 0; i < data.answer_collection.length; i++) {
        answer.parts.push({index: ko.observable(i), part: ko.observable('')});
      }
      data.question_answers.push(answer);
    }

    //If this is a resubmission grab the existing answers and seed them into the question_answers array
    if (data.question_answer()) {
      var mapped_answers = ko.mapping.fromJS(data.question_answer());
      data.question_answers(mapped_answers());
    }

    //Subscribe to all the answer fields
    ko.computed(function() {
      var json_data = ko.mapping.toJSON(data.question_answers());
      data.question_answer(json_data);

      //Update question status
      var completed = _.all(data.question_answers(), function(answer) {
        return _.all(answer.parts(), function(part) {
          return !_.isEmpty(part.part());
        });
      });
      data.isCompleted(completed);
    });
  }

  return ko.mapping.fromJS(data, mapping || {});
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
CourseworkFields.TimelineField = function TimelineField(data, parent, mapping) {
  var data = new CourseworkFields.BaseField(data, parent, true);
  data.isRequired(true);
  data.milestones = data.field_definition[data.rand_fd_index()].milestones || [];
  data.start_date = ko.observable(data.field_definition[data.rand_fd_index()].start_date || 'N.A');
  data.end_date = ko.observable(data.field_definition[data.rand_fd_index()].end_date || 'N.A');

  if(data.isGraded()) {
    //Transform existing answers into an array for presentation

    //First, inject the individual milestone scores from the grader into the question_answer array
    var raw_scores = Kadenze.Util.objFromString(data, 'grade_entry.autograde_output.data.raw_scores', []);
    raw_scores = Array.prototype.slice.call(raw_scores).reverse();
    _.each(data.question_answer(), function(answer, index) { answer.score = raw_scores[index]; });

    var mapped_answers = ko.mapping.fromJS(data.question_answer());
    data.question_answers(mapped_answers());

    data.isCompleted(true);
  } else {
    //Build an array to store the # of answers required from the student based on the # of milestones there are in the selected variant
    for (var i = 0; i < data.milestones.length; i++) {
      var answer = {index: ko.observable(i), date: ko.observable()};
      data.question_answers.push(answer);
    }

    //If this is a resubmission grab the existing answers and seed them into the question_answers array
    if (data.question_answer()) {
      var mapped_answers = ko.mapping.fromJS(data.question_answer());
      data.question_answers(mapped_answers());
    }

    //Subscribe to all the answer fields
    ko.computed(function() {
      var json_data = ko.mapping.toJSON(data.question_answers());
      data.question_answer(json_data);

      //Update question status
      var completed = _.all(data.question_answers(), function(answer) {
        return !_.isEmpty(answer.date());
      });
      data.isCompleted(completed);
    });
  }

  return ko.mapping.fromJS(data, mapping || {});
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
CourseworkFields.InteractiveTimelineField = function InteractiveTimelineField(data, parent, mapping) {
  ko.bindingHandlers.timelineSlick = (function() {
    var createSlide = function(item) {
      var $slide = $(JST['templates/dynamic_fields/submission/interactive_timeline_slider_item']({}));
      ko.applyBindingsWithValidation(item, $slide[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
      return $slide;
    };

      // Initializes the carousel
    var init = function(element, valueAccessor, allBindingsAccessor) {
      var $el = $(element);
      var subscriptions = [];
      var options = ko.utils.unwrapObservable(allBindingsAccessor().slickOptions || {});
      options.prevArrow = $('.js-timelineSlickLeft')[0];
      options.nextArrow = $('.js-timelineSlickRight')[0];

      // Clears the div
      $el.empty();

      var bindItems = function (items) {
        _.each(subscriptions, function (s) { s.dispose(); });
        subscriptions = [];
        _.each(items, function(item) {
          if (!item.added()) {
            var data = _.extend({}, item, options.customEvents);
            var el = createSlide(data);
            $el.append(el);
          }
          subscriptions.push(item.added.subscribe(function () {
            $el.slick('unslick');
            $el.empty();
            bindItems(ko.unwrap(valueAccessor()));
            $el.slick(options);
          }));
        });
      };

        // Creates the inner divs with images
      bindItems(ko.unwrap(valueAccessor()));

      // Initialize slick on the div, with provided options
      $el.slick(options);
      setTimeout(function () {
        $el[0].slick.refresh();
      }, 300);

      //handle disposal, if KO removes the element
      ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
        $(element).slick('unslick');
      });
    };

      //update the control when the view model changes
    var update = function(element, valueAccessor) {
      // Do something to update the content
      console.log('ko.bindingHandlers.slick.update');
    };

    return { init: init, update:update };
  })();
  var data = new CourseworkFields.BaseField(data, parent, true);
  var milestones = data.field_definition[data.rand_fd_index()].milestones || [];
  var mapped_milestones = ko.mapping.fromJS(milestones, {
    'update': function (options) {
      return ko.mapping.fromJS(_.extend(options.data, {
        'added': ko.observable(false)
      }));
    }
  });
  data.milestones = ko.observableArray(mapped_milestones());
  data = ko.mapping.fromJS(data, mapping || {});

  data.isRequired(true);
  data.set_scores = ko.observableArray([]);
  data.vis_dataset = new vis.DataSet([]);
  data.timeline = null;
  data.zoom_min = ko.computed(function () {
    var granularity = data.getFDObj(data).granularity();
    var zoomMin;
    switch (granularity) {
    case 'century':
      zoomMin = 1000 * 60 * 60 * 24 * 30 * 12 * 1000;
      break;
    case 'decade':
      zoomMin = 1000 * 60 * 60 * 24 * 30 * 12 * 100;
      break;
    case 'year':
      zoomMin = 1000 * 60 * 60 * 24 * 30 * 12 * 10;
      break;
    case 'month':
      zoomMin = 1000 * 60 * 60 * 24 * 30 * 12;
      break;
    case 'day':
      zoomMin = 1000 * 60 * 60 * 24 * 30;
      break;
    default:
      zoomMin = 1000 * 60 * 60 * 24 * 30;
    }
    return zoomMin;
  });
  data.showCorrectAnswers = ko.observable(false);
  data.showCorrectAnswers.subscribe(function (showCorrectAnswers) {
    if (showCorrectAnswers) {
      _.each(data.milestones(), function (milestone) {
        var placedMilestone = data.vis_dataset.get(milestone.id());
        if (!placedMilestone || placedMilestone.className != 'graded correct') {
          var correctMilestone = ko.mapping.toJS(milestone);
          correctMilestone.id = 'correct-' + correctMilestone.id;
          correctMilestone.className = 'correct';
          correctMilestone.attachment = milestone.attachment;
          correctMilestone.content += ` (${moment(milestone.start()).format(data.getDateFormat().toUpperCase())})`;
          data.vis_dataset.add(correctMilestone);
          if (placedMilestone) {
            placedMilestone.className = placedMilestone.className + ' ' + 'faded';
            data.vis_dataset.update(placedMilestone);
          }
        }
      });
    } else {
      data.vis_dataset.forEach(function(item) {
        data.vis_dataset.remove(item.id);
        var id = item.id.replace('correct-', '');
        var placedItem = data.vis_dataset.get(id);
        if (placedItem) {
          placedItem.className = placedItem.className.replace('faded', '');
          data.vis_dataset.update(placedItem);
        }
      },{
        filter: function (item) {
          return item.className == 'correct';
        }
      });
    }
  });

  data.initTimeline = function () {
    if (data.timeline)
      return;

    var $container = $('#submission-field-' + data.id());
    var $timeline = $container.find('#js-timeline');

    var options = {
      editable: data.isDisabled() ? false : {
        add: false,         // add new items by double tapping
        updateTime: true,  // drag items horizontally
        updateGroup: false, // drag items from one group to another
        remove: true       // delete an item by tapping the delete button top right
      },
      selectable: !data.isDisabled(),
      customAction: {
        title: 'View this item',
        className: 'vis-view',
        onClick: data.viewMilestone
      },
      height: '400px',
      onAdd: data.addMilestone,
      onMove: data.moveMilestone,
      onRemove: data.removeMilestone,
      min: moment('0001'),
      zoomable: true,
      zoomMin: this.zoom_min(),
      zoomMax: 1000 * 60 * 60 * 24 * 30 * 12 * 1000, //Century
      template: JST['templates/dynamic_fields/submission/interactive_timeline_milestone'],
      format: data.getTimelineFormatObj(),
      snap: data.getSnappedDate
    };

      //Create the timeline
    data.timeline = new vis.Timeline($timeline[0]);
    data.timeline.setOptions(options);
    data.timeline.setItems(data.vis_dataset);
    data.timeline.on('select',data.milestoneSelect);
    setTimeout(function () {
      data.timeline.moveTo(moment(data.getFDObj(data).midpoint()));
      data.timeline.zoomIn(1);
    }, 300);
  };
  data.getTimelineFormatObj = function () {
    return {
      minorLabels: function (date, scale, step) {
        var label = '';
        var defaultFormats = {
          millisecond:'SSS',
          second:     's',
          minute:     'HH:mm',
          hour:       'HH:mm',
          weekday:    'ddd D',
          day:        'D',
          month:      'MMM',
          year:       'YYYY'
        };
        if (scale == 'year' && step == 100) {
          var year = parseInt(date.year()) / 100;
          var century = year + 1;
          label = Kadenze.Util.getOrdinal(century) + ' Century';
        } else {
          label = date.format(defaultFormats[scale]);
        }
        return label;
      },
      majorLabels: function (date, scale, step) {
        var date = moment(date);
        var label = '';
        var defaultFormats = {
          millisecond:'HH:mm:ss',
          second:     'D MMMM HH:mm',
          minute:     'ddd D MMMM',
          hour:       'ddd D MMMM',
          weekday:    'MMMM YYYY',
          day:        'MMMM YYYY',
          month:      'YYYY',
          year:       ''
        };
        if (scale == 'year' && step >= 1 && step <= 5) {
          //Show decade
          var decade = Math.floor(parseInt(date.year() / 10)) * 10;
          label = decade + '\'s';
        } else if (scale == 'year' && step >= 10 && step <= 50) {
          //Show century
          var century = Math.floor(parseInt(date.year()) / 100) + 1;
          label = Kadenze.Util.getOrdinal(century) + ' Century';
        } else if (!_.isEmpty(defaultFormats[scale])) {
          label = date.format(defaultFormats[scale]);
        }
        return label;
      }
    };
  };
  data.getDateFormat = function () {
    var format = {};
    switch (data.getFDObj(data).granularity()) {
    case 'century':
    case 'decade':
    case 'year':
      format = 'yyyy';
      break;
    case 'month':
      format = 'mm/yyyy';
      break;
    case 'day':
    default:
      format = 'mm/dd/yyyy';
    }
    return format;
  };
  data.getSnappedDate = function (date, scale, step) {
    var clone = moment(date);
    if (scale == 'year') {
      var modifiedStep;
      switch (data.getFDObj(data).granularity()) {
      case 'century':
        modifiedStep = 100;
        break;
      case 'decade':
        modifiedStep = 10;
        break;
      case 'year':
        modifiedStep = 1;
        break;
      }
      var year = clone.year() + Math.round(clone.month() / 12);
      clone.year(Math.round(year / modifiedStep) * modifiedStep);
      clone.month(0);
      clone.date(1);
      clone.hours(0);
      clone.minutes(0);
      clone.seconds(0);
      clone.milliseconds(0);
    } else if (scale == 'month') {
      if (clone.date() > 15) {
        clone.date(1);
        clone.add(1, 'month');
      } else {
        clone.date(1);
      }
      clone.hours(0);
      clone.minutes(0);
      clone.seconds(0);
      clone.milliseconds(0);
    } else if (scale == 'day') {
      switch (step) {
      case 5:
      case 2:
        clone.hours(Math.round(clone.hours() / 24) * 24);
        break;
      default:
        clone.hours(Math.round(clone.hours() / 12) * 12);
        break;
      }
      clone.minutes(0);
      clone.seconds(0);
      clone.milliseconds(0);
    }
    return clone;
  };
  data.addMilestone = function (item, event) {
    var window = data.timeline.getWindow();
    var midpoint = moment((window.start.getTime() + window.end.getTime()) / 2).format();
    data.vis_dataset.add({id: item.id(), content: item.content(), attachment: item.attachment, start: midpoint});
    data.saveTimeline();
    data.updateMilestoneStatus(item.id(), true);
  };
  data.milestoneSelect = function(properties){
    var self = this;
    //Reset previously selected milestones
    this.itemSet.itemsData.forEach(function (item) {
      self.itemSet.itemsData.update(_.extend({}, item, {selected: false}));
    }, {filter: function (item) { return (item.selected == true); }});
    //Mark this milestones as selected
    if (properties.items.length > 0) {
      var id = properties.items[0];
      var item = this.itemSet.itemsData.get(id);
      this.itemSet.itemsData.update(_.extend({}, item, {selected: true}));
    }
    this.redraw();
  };
  data.moveMilestone = function (item, callback) {
    callback(item);
    data.saveTimeline();
  };
  data.viewMilestone = function (item) {
    var itemData = item.parent.itemSet.itemsData.get(item.id);
    var attachment = itemData.attachment;
    if (_.isEmpty(attachment)) {
      attachment = {file: {file: {url: null}}, meta: {type: 'text'}, text_data: itemData.content};
    } else {
      attachment.text_data = itemData.content;
    }
    Kadenze.MediaFileActions.preview(ko.mapping.toJS(attachment, {ignore: ['name']}));
  };
  data.viewMilestoneExternal = function (item) {
    var attachment = item.attachment;
    if (_.isEmpty(attachment)) {
      attachment = {file: {file: {url: null}}, meta: {type: 'text'}, text_data: item.content()};
    } else {
      attachment.text_data = item.content();
    }
    Kadenze.MediaFileActions.preview(ko.mapping.toJS(attachment, {ignore: ['name']}));
  };
  data.removeMilestone = function (item, callback) {
    Kadenze.UIUtil.confirmAction('Are you sure you want to remove this milestone?', function () {
      callback(item); // confirm deletion
      data.saveTimeline();
      data.updateMilestoneStatus(item.id, false);
    }, function () {
      callback(null);
    });
  };
  data.saveTimeline = function () {
    var exported_milestones = data.vis_dataset.get({
      type: {
        start: 'ISODate'
      }
    });
    data.question_answer(ko.mapping.toJSON(exported_milestones, {ignore: 'attachment'}));
  };
  data.zoomIn = function () {
    data.timeline.zoomIn(1);
  };
  data.zoomOut = function () {
    data.timeline.zoomOut(1);
  };
  data.goToCurrent = function () {
    data.timeline.moveTo(new Date());
  };
  data.getMilestoneById = function (id) {
    return _.find(data.milestones(), function (milestone) {
      return milestone.id() == id;
    });
  };
  data.getIndexOfAnswerMilestoneById = function (id) {
    var ids = _.map(data.question_answer(), function (answer) { return answer.id(); });
    var sorted_ids = _.sortBy(ids, function (id) { return id; });
    return _.indexOf(sorted_ids, id);
  };
  data.getAnswerMilestoneClassName = function (id) {
    var className = '';
    if (data.isGraded()) {
      var index = data.getIndexOfAnswerMilestoneById(id);
      if (data.set_scores()[index] == 1) {
        className = 'graded correct';
      } else if (data.set_scores()[index] > 0 && data.set_scores()[index] < 1) {
        className = 'graded partially_correct';
      } else if (data.set_scores()[index] == 0) {
        className = 'graded incorrect';
      }
    }
    return className;
  };
  data.updateMilestoneStatus = function(id, status) {
    var milestone = data.getMilestoneById(id);
    if (milestone) {
      milestone.added(status);
    }
  };
  data.getFirstSlickSlide = function () {
    var $container = $('#submission-field-' + data.id());
    return $($container.find('.slick-track').children()[0]);
  };
  data.milestoneTooltipShown = function () {
    var $slide = data.getFirstSlickSlide();
    var $actions = $slide.find('.interactive-timeline__select-milestone_actions');
    $actions.css('opacity', '1');
  };
  data.milestoneTooltipHidden = function () {
    var $slide = data.getFirstSlickSlide();
    var $actions = $slide.find('.interactive-timeline__select-milestone_actions');
    $actions.css('opacity', '');
  };
  data.slickOpts = ko.computed(function () {
    return {
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows:true,
      dots: false,
      prevArrow: null,
      nextArrow: null,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },{
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },{
          breakpoint: 540,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ],
      customEvents: {
        add: data.addMilestone,
        view: data.viewMilestoneExternal
      }
    };
  });

  if(data.isGraded()) {
    data.set_scores(data.grade_entry.set_scores());
    data.isCompleted(true);
  } else {
    //Check completed status
    ko.computed(function() {
      //Update question status
      var completed = _.all(data.milestones(), function(milestone) {
        return milestone.added();
      });
      data.isCompleted(completed);
    });
  }

  //Add existing answers aka milestones onto the timeline
  _.each(data.question_answer(), function (answer) {
    var milestone = data.getMilestoneById(answer.id());
    var className = data.getAnswerMilestoneClassName(answer.id());
    data.vis_dataset.add({id: answer.id(), content: answer.content(), attachment: milestone.attachment, start: answer.start(), className: className});
    milestone.added(true);
  });

  return data;
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
CourseworkFields.MatrixField = function MatrixField(data, parent, mapping) {
  var data = new CourseworkFields.BaseField(data, parent, true);
  var fd = data.field_definition[data.rand_fd_index()];
  if (!_.isEmpty(fd.na_column) && fd.na_column.enabled == true) {
    fd.columns.push(fd.na_column.label);
  }
  fd.getOptGroupId = function(context) {
    var rowIndex = context.$parentContext.$index();
    return 'opt-' + data.id + '-' + rowIndex;
  };
  fd.getOptId = function(context) {
    var colIndex = context.$index();
    return fd.getOptGroupId(context) + '-' + colIndex;
  };
  fd.getOptValue = function(context) {
    var qa = context.$parents[2].question_answers();
    var rowIndex = context.$parentContext.$index();
    var colIndex = context.$index();
    return qa[rowIndex].columns()[colIndex].selected;
  };
  fd.clearRow = function(context) {
    var qa = context.$parents[2].question_answers();
    var rowIndex = context.$parentContext.$index();
    var colIndex = context.$index();
    _.each(qa[rowIndex].columns(), function (col, index) { if (colIndex != index) { col.selected(false); } });
    return true;
  };

  //Build a 2d array to store the # of answers required from the student based on the # of cols/rows there are in the selected variant
  var number_of_rows = parseInt(fd.rows.length || 1);
  var number_of_cols = parseInt(fd.columns.length || 1);
  for (var a = 0; a < number_of_rows; a++) {
    var row = {index: ko.observable(a), columns: ko.observableArray([])};
    for (var i = 0; i < number_of_cols; i++) {
      row.columns.push({index: ko.observable(i), selected: ko.observable(false)});
    }
    data.question_answers.push(row);
  }

  //Subscribe to all the answer fields
  ko.computed(function() {
    var json_data = ko.mapping.toJSON(data.question_answers());
    data.question_answer(json_data);

    //Update question status
    var fn = fd.multi_response ? _.any : _.all;
    var completed = fn(data.question_answers(), function(row) {
      return _.any(row.columns(), function(column) {
        return column.selected();
      });
    });

    data.isCompleted(completed);
  });

  return ko.mapping.fromJS(data, mapping || {});
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
CourseworkFields.ImageMatchingField = function ImageMatchingField(data, parent, mapping) {
  var data = new CourseworkFields.BaseField(data, parent, true);
  data.isRequiredConfirmation(true);
  data.question_answers = ko.observable();
  data.questions = ko.observableArray(data.field_definition[data.rand_fd_index()].questions || []);
  data.answers = ko.observableArray(_.shuffle(data.field_definition[data.rand_fd_index()].answers || []));
  data.selected_question_id = ko.observable(_.isEmpty(data.questions()) ? -1 : data.questions()[0].id);
  data.question_answer_ids = ko.observable({});
  data.set_scores = ko.observableArray([]);
  data.grading_format = ko.observable(data.field_definition[data.rand_fd_index()].grading_format);

  if(data.isGraded()) {
    //Transform existing answers into an array for presentation
    var mapped_answers = ko.mapping.fromJS(data.question_answer());
    data.question_answers(mapped_answers);

    data.question_answer_ids(data.field_definition[data.rand_fd_index()].question_answer_ids);
    data.set_scores(data.grade_entry.set_scores);

    data.isCompleted(true);
  } else {
    //Build an array to store the # of answers required from the student based on the # of answer collections there are in the selected variant
    var answers = {};
    _.each(data.questions(), function(question) {
      answers[question.id] = ko.observableArray([]);
    });
    data.question_answers(answers);

    //If this is a resubmission grab the existing answers and seed them into the question_answers array
    if (data.question_answer()) {
      //Re-seed the question answer hash with observable arrays
      var qas = data.question_answer();
      _.each(_.keys(qas), function(id) {
        qas[id] = _.isArray(qas[id]) ? ko.observableArray(qas[id]) : ko.observableArray([]);
      });
      data.question_answers(qas);
    }

    //Subscribe to all the answer fields
    ko.computed(function() {
      var json_data = ko.mapping.toJSON(data.question_answers());
      data.question_answer(json_data);

      //Update question status
      var completed = _.all(_.values(data.question_answers()), function(answer) {
        return !_.isEmpty(answer());
      });

      data.isCompleted(completed);
    });
  }

  data.selectQuestion = function(item, index) {
    data.selected_question_id(item.id());
  };

  data.selectedQuestion = ko.computed(function() {
    return _.find(data.questions(), function(question) {
      return question.id == data.selected_question_id();
    });
  });

  data.getSelectedQuestionAnswers = function() {
    var sa = null;
    if (data.question_answers()[data.selected_question_id()]) {
      var selected_ids = data.question_answers()[data.selected_question_id()]();
      if (data.selected_question_id() && selected_ids.length > 0) {
        sa = _.filter(data.answers(), function(answer) {
          return _.includes(selected_ids, answer.id);
        });
      }
    }
    return sa || [];
  };

  data.viewQuestion = function(item, event) {
    Kadenze.MediaFileActions.preview(ko.mapping.toJS(item, {ignore: ['name']}));
  };

  data.isQuestionSelected = function(item) {
    return data.selectedQuestion().id == item.id();
  };

  data.isQuestionCompleted = function(item) {
    return data.question_answers()[item.id()] && data.question_answers()[item.id()]().length > 0;
  };

  data.areAnswersCorrect = function (index) {
    return data.isGraded() && data.set_scores()[index()] == 1;
  };

  data.areAnswersPartiallyCorrect = function (index) {
    return data.isGraded() && data.set_scores()[index()] > 0 && data.set_scores()[index()] < 1;
  };

  data.areAnswersIncorrect = function (index) {
    return data.isGraded() && data.set_scores()[index()] == 0;
  };

  data.isAnswerSelected = function(item) {
    return data.question_answers()[data.selected_question_id()] && _.include(data.question_answers()[data.selected_question_id()](), item.id());
  };

  data.isAnswerCorrect = function(item) {
    return data.isGraded() && _.include(data.question_answer_ids()[data.selected_question_id()], item.id());
  };

  data.isAnswerIncorrect = function(item) {
    return data.isGraded() && !_.include(data.question_answer_ids()[data.selected_question_id()], item.id());
  };

  return ko.mapping.fromJS(data, mapping || {});
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
CourseworkFields.SectionBreakField = function SectionBreakField(data, parent, mapping) {
  var data = new CourseworkFields.BaseField(data, parent, true);

  data.getSectionTitle = function(item, index) {
    var break_ids = _.map(_.reject(parent.coursework_fields(), function(field) { return !field.isSectionBreak(); }), function(sb) { return sb.id(); });
    var break_index = _.indexOf(break_ids, item.id());
    return 'Section ' + (break_index + 1);
  };

  return ko.mapping.fromJS(data, mapping || {});
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default CourseworkFields;
